import { styled, TextField, useTheme } from '@mui/material'
import ErrorMessage from './ErrorMessage'

const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'width'

})(({ width }) => ({
  width
}))

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'error'

})(({ theme, error, variant }) => ({
  backgroundColor: theme.palette.textField.backgroundColor,
  borderRadius: '8px',
  outlineWidth: (error && variant !== 'outlined') ? '2px' : '0',
  outlineColor: theme.palette.status.error,
  outlineStyle: 'solid',
  color: '#FFFFFF',
  borderWidth: variant === 'outlined' ? '0px' : theme.palette.textField.borderWidth,
  borderColor: (!!error && variant === 'outlined') ? theme.palette.status.error : theme.palette.mainText.main,
  borderStyle: 'solid',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: (!!error) ? theme.palette.status.error : theme.palette.textField.outlinedBorderColor,
    },
    color: theme.palette.mainText.main,
  },
  '& .MuiFilledInput-root': {
    color: theme.palette.mainText.main,
  }
}))

const StyledErrorMessage = styled(ErrorMessage)({
  marginTop: '4px'
})

const TextInput = ({ className, errorMessage, variant = 'filled', width='100%', redErrorText=false, InputLabelProps, ...props }) => {
  const theme = useTheme()
  return (
    <Container width={width} style={props.style}>
    <StyledTextField
      className={className}
      InputProps={{ disableUnderline: true }}
      variant={variant}
      error={!!errorMessage}
      InputLabelProps={{
        style: { color: theme.palette.mainText.main, opacity: 0.7, ...InputLabelProps },
      }}{...props} />
      {!!errorMessage && <StyledErrorMessage errorMessage={errorMessage} redText={redErrorText}/> }
    </Container>
  )
}

export default TextInput
